import { styled } from 'styled-components';

const Field = styled.div`
    border: none;
    padding: 0;
    margin: 0;
`;

Field.displayName = 'BaseField';

export default Field;
